import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { BackboneViewProps } from '../../types';
import OutreachParentComponent from './ReactComponents/OutreachParentComponent';

const template = require('./index.pug');

export default (Backbone as any).Epoxy.View.extend({
  initialize(options: BackboneViewProps) {
    this.tenant = options.tenant;
    this.integration = 'outreach';
    setTimeout(() => {
      this.render();
      this.renderOutreachIntegrationComponent();
    }, 250);
  },

  renderOutreachIntegrationComponent() {
    const containerDomElement = $('#OutreachParentComponentContainer')[0];

    if (typeof containerDomElement !== 'undefined') {
      ReactDOM.render(
        <OutreachParentComponent tenant={this.tenant} />,
        containerDomElement
      );
    }
  },

  render() {
    this.$el.empty();
    const html = template();
    this.$el.html(html);
  },
});
